module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.8e066167.png";